// extracted by mini-css-extract-plugin
module.exports = {"iconStyle":"SignalsData-module__iconStyle___2X7rz"};